import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment-timezone';

import format from 'app/helpers/format';

// if a cell starts with one of these, it could trigger a formula to execute
const formulaStarters = new Set(['+', '-', '=', '@']);

const quote = (val) => {
  if (val == null) return `""`;
  let stringVal = `${val}`.trim();
  if (!stringVal) return `""`;
  stringVal = stringVal.replace(/"/g, '""');
  if (formulaStarters.has(stringVal[0])) {
    stringVal = `'${stringVal}`;
  }
  return `"${stringVal}"`;
};

const usd = (val) => {
  if(!_.isFinite(val)) return '';
  const fmt = numeral(val / 100).format('$0,0.00');
  return quote(fmt);
};

const dateOnly = (val, timezone) => {
  if (!val) return '';
  const m = timezone ? moment.tz(val, timezone) : moment(val);
  return m.format('YYYY-MM-DD');
};

const timestamp = (val, timezone) => {
  if (!val) return '';
  const m = timezone ? moment.tz(val, timezone) : moment.utc(val);
  return m.format();
};

const hours = (valMinutes) => {
  if (!_.isFinite(valMinutes)) return '';
  const fmt = numeral(valMinutes / 60).format('0.00');
  return quote(fmt);
};

const int = (val) => {
  if (!_.isFinite(val)) return '';
  const fmt = numeral(val).format('0,0');
  return quote(fmt);
};

const bool = (val) => {
  if (val === true) return 'yes';
  if (val === false) return 'no';
  return '';
};

const ein = (val) => {
  if (!val) return '';
  return format.ein(val);
};

export default {
  quote,
  usd,
  dateOnly,
  timestamp,
  hours,
  int,
  bool,
  ein,
};
